import React from 'react';
import { Flex, Icon } from '@chakra-ui/react';
import { KTag, KText } from '@/ui-library/components';
import { Calendar } from '@kula-ai/icons/dual-tone/Calendar';
import { ScheduleDisplayProps } from '../types';

export const ScheduleDisplay = ({
  scheduleDetail,
  selectedReport,
}: ScheduleDisplayProps) => {
  return (
    <Flex
      gap="6px"
      flexDirection="column"
      my="12px"
      bg="primary-25"
      borderRadius="sm"
      p="12px"
    >
      <Flex gap="6px" alignItems="center">
        <Icon as={Calendar} color="primary-500" />
        <KText size="sm-medium" color="primary-900">
          Schedule
        </KText>
        {selectedReport?.status === 'paused' && (
          <KTag
            value={selectedReport?.status}
            bg="white"
            borderColor="border-color"
            textTransform="capitalize"
            borderRadius="sm"
            size="sm-semi-bold"
            color="secondary-700"
          >
            {selectedReport?.status}
          </KTag>
        )}
      </Flex>
      <KText>{scheduleDetail}</KText>
    </Flex>
  );
};
